module.exports = __webpack_public_path__ + "img/fire-smoke-source-2.e13549a9.png";